module.exports = __webpack_public_path__ + "static/img/010.359079ac.jpg";